import semver from "semver";
export function shouldUseTrustedInputForSegwit(_ref) {
  var version = _ref.version,
      name = _ref.name;
  if (name === "Decred") return false;
  if (name === "Exchange") return true;
  return semver.gte(version, "1.4.0");
}